/**
 * Compute the time difference between two given Dates in Milliseconds
 * Assumes that the second date in the tuple (to) is larger than the first one (from)
 */
export function getTimeRange(resolution: [Date, Date]): number {
  return resolution[1].getTime() - resolution[0].getTime();
}
